import styled from 'styled-components';

interface GradientSwatchWrapperType {
  gradient: string;
}
export const GradientSwatchWrapper = styled.div`
  background: ${(props: GradientSwatchWrapperType) => props.gradient};
  width: 100px;
  height: 36px;
  border-radius: 18px;
`;
